<widget-header
  [name]="widgetName"
  [editable]="isEditable">

  <attribute-help-text slot="prepend"
                       attribute="status"
                       [attributeScope]="'Project'" />

  <widget-menu slot="menu"
    [resource]="resource" />
</widget-header>

<div class="op-widget-box--body -allow-inner-overflow">
  <turbo-frame [id]="frameId" [src]="src" />
</div>
